var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewArea",staticClass:"ly-tabbar",class:{'ly-tabbar-fix-bottom': _vm.fixBottom},staticStyle:{"height":"45px"}},[_c('div',{ref:"list",staticClass:"ly-tab-list",style:(_vm.style)},[_vm._t("default"),_vm._v(" "),(!_vm.fixBottom)?_c('div',{ref:"activeBar",staticClass:"ly-tab-active-bar",style:(_vm.activeBarStyle)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04efecbd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/tab/src/tabbar.vue
// module id = null
// module chunks = 